export const nonBuildableTooltipText = (unBuildableOption) => {
  const { unbuildableEngineCode, unbuildableEngineError } = unBuildableOption;
  if (unbuildableEngineCode && unbuildableEngineError) {
    return `This model is non-buildable due to "${unbuildableEngineError}" for "${unbuildableEngineCode}" engine.`;
  }

  return `This model is non-buildable due to unresolved conflicts.`;
};
